// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_ids-foundation_icons_new_standard_path-data_json"], () => (__webpack_require__("./src/components/ids-icon/demos/example.ts")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
